import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { BrowseContext } from "../../../contexts/BrowseContext";
import KpiMetricsRow from "./CampaignsBrowseParts/KpiMetricsRow";

export default observer(function CampaignsHeader() {
  const { allCampaigns, clientCampaigns, selectedFolder } = useContext(BrowseContext);
  const { folder_id } = useParams();

  const campaigns = folder_id
    ? clientCampaigns.filter((camp) => +camp.folder_id === +folder_id)
    : allCampaigns;

  const heading = folder_id ? (selectedFolder?.name || "Campaigns") : "Campaigns";
  const budgetTitle = folder_id ? "Total Budget" : "All campaigns budget";

  return (
    <section
      style={{ top: 52 }}
      className="fixed w-full h-[236px] pb-4 pl-64 overflow-hidden flex flex-col items-center justify-center -z-0 bg-[#F0F5F4] dark:bg-rb-dark-mode"
    >
      {/* Left background - light mode */}
      <img
        className="h-64 w-64 absolute -bottom-10 left-48 -z-5 block dark:hidden"
        src="/static/background_images/left-light.png"
        alt="background lines left"
      />
      {/* Left background - dark mode */}
      <img
        className="h-64 w-64 absolute -bottom-10 left-48 -z-5 hidden dark:block"
        src="/static/background_images/left-dark.png"
        alt="background lines left"
      />
      {/* Right background - light mode */}
      <img
        className="h-64 w-64 absolute -top-10 -right-20 -z-5 block dark:hidden"
        src="/static/background_images/right-light.png"
        alt="background lines right"
      />
      {/* Right background - dark mode */}
      <img
        className="h-64 w-64 absolute -top-10 -right-20 -z-5 hidden dark:block"
        src="/static/background_images/right-dark.png"
        alt="background lines right"
      />
      <h1 className="font-semibold text-2xl pt-5 mb-8 dark:text-white">
        {heading}
      </h1>
      <KpiMetricsRow campaigns={campaigns} budgetTitle={budgetTitle} />
    </section>
  );
});
